module.exports = __webpack_public_path__ + "img/石榴集团.3771644f.png";